export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://16a3dce08c30.ngrok-free.app', // Ngrok tunnel for Development Backend
  googleMapsApiKey: 'AIzaSyAEROSIualKqbxYfFsNTf_NAKMNb9D3pig',
  firebaseConfig: {
    apiKey: 'AIzaSyDhBsnv2J-ZIXBVnXAXNM4GkBKQtvNTYyw',
    authDomain: 'geneva-protection-dev.firebaseapp.com',
    projectId: 'geneva-protection-dev',
    storageBucket: 'geneva-protection-dev.firebasestorage.app',
    messagingSenderId: '702479128192',
    appId: '1:702479128192:web:8b6b981b8b9a8966137865'
  },
  dataProvider: 'local' as 'local' | 'synology',
  signalrHubUrl: 'http://localhost:3001/hub', // SignalR direct PC Engine
  loadBalancer: {
    enabled: true,
    stagingUrl: 'http://localhost:8080',
    productionUrl: 'http://localhost:8081',
    statusEndpoint: '/dev-status'
  }
};